import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("section", null, [
          (!_ctx.spinning)
            ? (_openBlock(), _createBlock(_component_Nodata, {
                key: 0,
                emptyInfo: _ctx.emptyInfo
              }, null, 8, ["emptyInfo"]))
            : _createCommentVNode("", true)
        ])
      ], true)
    ]),
    _: 3
  }, 8, ["spinning"]))
}